<template>
<v-container fluid>
  <div class="page-shell">
    <notification-dialog></notification-dialog>
    <filter-form-location/>
    <dialog-form-location v-if="canWriteLocations"/>
    <location-type-manager v-if="canReadLocationTypes" v-model="typeManagerOpen" @changed="refreshLocations"/>
    <v-card class="page-card">
      <v-toolbar color="primary" class="page-toolbar location-toolbar">
        <v-toolbar-title class="location-toolbar-title">Ubicaciones Origen/Destino</v-toolbar-title>
        <div class="location-toolbar-actions">
          <v-btn v-if="canReadLocationTypes" color="secondary" variant="flat" prepend-icon="category" class="location-toolbar-button" @click="typeManagerOpen = true">Tipos de lugar</v-btn>
          <v-btn v-if="canCreateLocation" color="white" variant="flat" prepend-icon="add" class="toolbar-add-button location-toolbar-button" @click="addLocation()">Agregar Lugar</v-btn>
        </div>
      </v-toolbar>
      <div class="table-wrapper">
        <table-location/>
      </div>
    </v-card>
  </div>
</v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import FilterLocationForm from './FilterLocationForm'
import AddEditLocationForm from './AddEditLocationForm'
import LocationTable from './LocationTable'
import NotificationDialog from '../Common/NotificationDialog'
import LocationTypeManager from './LocationTypeManager'

export default {
  name: 'Location',
  components: {
    'filter-form-location': FilterLocationForm,
    'dialog-form-location': AddEditLocationForm,
    'table-location': LocationTable,
    'location-type-manager': LocationTypeManager,
    'notification-dialog': NotificationDialog
  },
  data: () => ({
    successMsg: '',
    typeManagerOpen: false
  }),
  computed: {
    ...mapGetters('authModule', ['hasPermission']),
    canCreateLocation () { return this.hasPermission('catalog.locations.create') },
    canWriteLocations () { return this.hasPermission('catalog.locations.create') || this.hasPermission('catalog.locations.update') },
    canReadLocationTypes () { return this.hasPermission('catalog.location_types.read') }
  },

  methods: {
    addLocation () {
      this.$store.dispatch('locationModule/setDialogActived', true)
    },
    refreshLocations () {
      this.$store.dispatch('locationModule/getLocations')
      this.$store.dispatch('locationModule/getBaseLocations')
    }
  }
}
</script>

<style scoped>
.location-toolbar-title {
  flex: 1 1 280px;
  min-width: 0;
  margin-right: 24px;
}

.location-toolbar-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 12px;
  margin-left: auto;
  padding-right: 16px;
}

@media (max-width: 760px) {
  .location-toolbar-title {
    margin-right: 0;
  }

  .location-toolbar-actions {
    margin-left: 0;
    padding: 0 16px 4px;
    width: 100%;
  }

  .location-toolbar-button {
    flex: 1 1 0;
  }
}
</style>
